import adminTool from './mainTranslation.json';

const translations = { ...adminTool };

export default translations;
